import { rest } from 'msw'
export default [
  /**
   * お知らせ一覧情報
   */
  rest.post('/api/v2/get_message_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items: [
            {
              id: 1,
              title:
                '【メンテナンス】お知らせが入りますお知らせが入りますお知らせが入ります',
              openDate: '915148799',
              closeDate: '915148799',
              important: 0,
            },
            {
              id: 2,
              title:
                '【利用規約の改定について】お知らせが入りますお知らせが入ります',
              openDate: '915148799',
              closeDate: '915148799',
              important: 0,
            },
            {
              id: 3,
              title:
                '【新機能】お知らせが入りますお知らせが入りますお知らせが入りますお知らせが入ります',
              openDate: '915148799',
              closeDate: '915148799',
              important: 0,
            },
          ],
          count: 30,
          totalCount: 50,
          responseTime: '915148799',
        },
      })
    )
  }),
  /**
   * お知らせ詳細情報
   */
  rest.post('/api/v2/get_message_detail_', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          id: 1,
          title:
            '【メンテナンス】お知らせが入りますお知らせが入りますお知らせが入ります',
          openDate: '915148799',
          closeDate: '915148799',
          details: [
            {
              seq: 1,
              icon: '1',
              title:
                '【メンテナンス】お知らせが入りますお知らせが入りますお知らせが入ります',
              text: 'ダミーテキスト、ダミーテキスト',
              image: '',
            },
            {
              seq: 2,
              icon: '2',
              title:
                '【利用規約の改定について】お知らせが入りますお知らせが入ります',
              text: 'ダミーテキスト、ダミーテキスト',
              image: '',
            },
          ],
          responseTime: '915148799',
        },
      })
    )
  }),
]
